<template>
  <b-alert show variant="primary">
    <h5>1. On <strong>their</strong> phone, get ORBITA-2 app:</h5>
    <ul>
      <li> Open Safari for iPhone or Chrome for Android, or either for laptop.</li>
      <li> Go to <strong>hq.orbita2.com</strong></li>
      <li>"Add to Home Screen" as follows:</li>
      <ul>
        <li> <em>Safari</em> &nbsp; Square-box-up-arrow at bottom, scroll 2nd row.
        </li>
        <li><em>Chrome</em> &nbsp; Triple dot at top right.
        </li>
      </ul>
      <li> Close Safari or Chrome</li>
    </ul>

    <h5>2. Open ORBITA-2 app icon and: </h5>
    <ul>
      <li>Patient enters email address (or family member's or create new gmail)
      </li>
      <li> Sets a password (at least 6 chars)
      </li>
      <li> <strong>You</strong> scroll down to Staff Only section, press "Create New Participant".<br>
      </li>
      <li>Say "Yes" to storing password (saves them grief later).</li>
    </ul>

    <h5>3. Tell ORBITA-2 system their details</h5>
    <ul>
      <li>Below this "help" message, click the patient's email, typically near the top.
      </li>
      <li>Activate them as a participant.</li>
      <li>
        They read privacy policy while you complete setup.
      </li>
      <li>
        Then help them through the practice on Bob.
      </li>
    </ul>

    <h5>Unblinded staff only have access until the date of randomization</h5>
    <ul>
      <li>So don't enter the date of randomization until it happens.
      </li>
      <li>If you accidentally enter an incorrectly early randomization date, and therefore lose access, ask a Blinded Researcher to correct the randomization date.</li>
    </ul>

  </b-alert>

</template>

<script>
export default {
  props: {
    isBlinded: { type: Boolean, default: false }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ResViewNewParticipantHelp.vue